export default "__VITE_ASSET__DEArytRi__"